module.exports = __webpack_public_path__ + "static/media/Talq-main.f7e89abd.jpg";